import {FC} from "react";

import {
  TabBlockAside,
  TabP,
  TabTitle,
  TabTitleDark,
  TableGrid,
} from "../styles";
import ImgArrowRight from "../../../assets/images/icon-tab-arrow-toright.svg";
import ImgNumber1 from "../../../assets/images/metodology-number1.svg";
import ImgNumber2 from "../../../assets/images/metodology-number2.svg";
import ImgNumber3 from "../../../assets/images/metodology-number3.svg";
// import ImgStep8 from "../../../assets/images/metodology-step8.svg";
// import ImgStep7 from "../../../assets/images/metodology-step7.svg";
// import ImgWeakSignalsIcon from "../../../assets/images/metodology-weaksignal-icon.svg";
import ImgRadarCRGCI from "../../../assets/images/metodology-radar-crgci.svg";

const SidebarInfoStateInitiative: FC = () => {
  return (
    <div style={{padding: "20px 30px"}}>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
            gap: 20,
          }}
        >
          <div style={{width: "40%"}}>
            <img src={ImgRadarCRGCI} alt="" width={160} />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Радиальный сегмент цифрового радара</TabTitle>
            <TabP>
              Национальная цифровая инфраструктура является фундаментом, на
              котором строятся важнейшие механизмы цифрового взаимодействия
              между гражданами, бизнесом и государством.
            </TabP>
            {/* <TabP>
              <i>Источники: аналитика АФТ, данные Всемирного банка</i>
            </TabP> */}
            <TabTitleDark style={{fontWeight: "200", color: "#737DA8"}}>
              Национальная цифровая инфраструктура (НЦИ) является совокупностью
              трех наиболее востребованных блоков:
            </TabTitleDark>

            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 11}}
              />
              <div>
                <ol style={{margin: 0, padding: 0}}>
                  <li>
                    <TabP style={{marginTop: 5}}>
                      Цифровая идентификация (Цифровой ID, биометрия)
                    </TabP>
                  </li>
                  <li>
                    <TabP>
                      Цифровые платежи (платформы быстрых/мгновенных платежей)
                    </TabP>
                  </li>
                  <li>
                    <TabP>
                      Обмен данными (доверенный доступ к данным и платформы
                      клиентских согласий)
                    </TabP>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>

      <TabBlockAside>
        <TabTitle>
          Распределение государственных цифровых инициатив по стадиям зрелости
          являются результатом комплексной оценки, состоящей из трех критериев:
        </TabTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <img src={ImgNumber1} alt="" height="30" />
            <TabP>Наличие законодательства</TabP>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <img src={ImgNumber2} alt="" height="30" />
            <TabP>Техническая готовность&nbsp;инициативы</TabP>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <img src={ImgNumber3} alt="" height="30" />
            <TabP>
              Готовности инфраструктуры государственных информационных систем
            </TabP>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <TabTitle>
          Как происходит оценка законодательной готовности государственной
          цифровой инициативы?
        </TabTitle>
        <TabP>
          Определяем на основании какого вида нормативного правового акта
          предусматривается реализация инициативы – федеральный закон или
          подзаконный нормативный правовой акт (постановление Правительства РФ
          или акт ответственного ФОИВ)
        </TabP>
        <div
          style={{
            backgroundColor: "#161A1D",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: "8px",
            margin: "10px 0",
            padding: "0 8px",
          }}
        >
          <TabP>
            Низкая степень зрелости государственной цифровой инициативы, если ее
            реализация предусмотрена:
          </TabP>
          <ul>
            <li>
              <TabP>
                Федеральным законом – законопроект внесен в Государственную
                Думу, отслеживается на портале СОЗД{" "}
                <a
                  href="https://sozd.duma.gov.ru/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://sozd.duma.gov.ru/
                </a>
              </TabP>
            </li>
            <li>
              <TabP>
                Подзаконным НПА – проект акта размещен для обсуждения на
                Федеральном портале проектов нормативных правовых актов
                <a
                  href="https://regulation.gov.ru/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://regulation.gov.ru/
                </a>
              </TabP>
            </li>
          </ul>
        </div>
        <div
          style={{
            backgroundColor: "#161A1D",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: "8px",
            margin: "10px 0",
            padding: "0 8px",
          }}
        >
          <TabP>
            Средняя степень зрелости государственной цифровой инициативы, если
            ее реализация предусмотрена:
          </TabP>
          <ul>
            <li>
              <TabP>
                Федеральным законом – законопроект принят Государственной Думой
                в первом чтении;
              </TabP>
            </li>
            <li>
              <TabP>
                Подзаконным НПА – на проект НПА получена оценка регулирующего
                воздействия.
              </TabP>
            </li>
          </ul>
        </div>
        <div
          style={{
            backgroundColor: "#161A1D",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: "8px",
            margin: "10px 0",
            padding: "0 8px",
          }}
        >
          <TabP>
            Высокая степень зрелости государственной цифровой инициативы, если
            ее реализация предусмотрена:
          </TabP>
          <ul>
            <li>
              <TabP>
                Федеральным законом – Федеральный закон опубликован на
                Официальном интернет-портале правовой информации
                <a
                  href="https://publication.pravo.gov.ru/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://publication.pravo.gov.ru/
                </a>
              </TabP>
            </li>
            <li>
              <TabP>
                Подзаконным НПА – НПА опубликован на Официальном
                интернет-портале правовой информации
                <a
                  href="https://publication.pravo.gov.ru"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://publication.pravo.gov.ru
                </a>
              </TabP>
            </li>
          </ul>
        </div>
      </TabBlockAside>

      <TabBlockAside>
        <TabTitle>Ниже представлена матрица оценки стадии зрелости:</TabTitle>
        <br />
        <TableGrid>
          <div className="grid-header">
            <div></div>
            <div style={{backgroundColor: "#D44242"}}>Низкая</div>
            <div style={{backgroundColor: "#C08B18"}}>Средняя</div>
            <div style={{backgroundColor: "#5F9526"}}>Высокая</div>
          </div>
          <div className="grid-row">
            <div>ФЗ (федеральный закон)</div>
            <div>Законопроект внесен в Госдуму</div>
            <div>Принят в первом чтении</div>
            <div>Опубликован на pravo.gov.ru</div>
          </div>
          <div className="grid-row">
            <div>Подзаконный НПА</div>
            <div>Проект акта размещен для обсуждения</div>
            <div>
              Размещен для обсуждения/ получена оценка регулирующего воздействия
            </div>
            <div>Опубликован</div>
          </div>
          <div className="grid-row">
            <div>Техническая готовность</div>
            <div>Отсутствует</div>
            <div>Запущена в промышленную эксплуатацию</div>
            <div>Высокая</div>
          </div>
          <div className="grid-row">
            <div>Инфраструктурная готовность</div>
            <div>Отсутствует</div>
            <div>Частично готова</div>
            <div>Готова</div>
          </div>
        </TableGrid>
        <TabP style={{fontWeight: "200"}}>
          <i>Методология формирования и расчета</i>
        </TabP>
        <TabP style={{fontSize: "16px"}}>
          Используются аналитические отчеты АФТ/Банка России, а также экспертная
          оценка сотрудников ЦРГЦИ
        </TabP>
        <TabP style={{fontWeight: "200"}}>
          <i>
            Источники: законодательство РФ, открытые данные (исследования),
            внутренние данные Банка, экспертная оценка.
          </i>
        </TabP>
      </TabBlockAside>
      {/* <TabBlockAside>
        <TabTitle>Текущий статус инициативы в банке</TabTitle>
        <TabP>
          Оценка динамики реализации государственной цифровой инициативы в
          Банке. Необходима для принятия обоснованных управленческих решений, а
          также оценки прогресса и выявления потенциальных рисков, в т.ч. в
          связи с изменением рыночной конъюнктуры.
        </TabP>
        <div
          style={{
            backgroundColor: "#181B28",
            border: "1px solid #4E5574",
            borderRadius: "8px",
            margin: "10px 0",
            padding: "0 8px",
          }}
        >
          <TabTitle style={{color: "white"}}>
            Для оценки статусов использована следующая шкала:
          </TabTitle>
          <TabP>
            <span
              style={{color: "#00F0FF", fontSize: "18px", fontWeight: "bold"}}
            >
              ≤1
            </span>{" "}
            – Обсуждение целесообразности реализации инициативы участниками
            финансового рынка
          </TabP>
          <TabP>
            <span
              style={{color: "#00F0FF", fontSize: "18px", fontWeight: "bold"}}
            >
              2-3
            </span>{" "}
            – Доработка концепции инициативы регуляторами или банковским
            сообществом, проведение первых пилотов
          </TabP>
          <TabP>
            <span
              style={{color: "#00F0FF", fontSize: "18px", fontWeight: "bold"}}
            >
              4-5
            </span>{" "}
            – Внедрение инициативы в бизнес-процессы core-бизнеса
          </TabP>
        </div>
        <TabP style={{fontWeight: 100}}>
          <i>Методология формирования и расчета</i>
        </TabP>
        <TabP style={{fontWeight: 100}}>
          <i>
            Источники: законодательные акты, исследования Банка России/АФТ,
            внутренние данные Банка
          </i>
        </TabP>
      </TabBlockAside> */}

      {/* <TabBlockAside>
        <TabTitle>Приоритетность инициативы</TabTitle>
        <TabP>
          Оценка приведена в соответствии со стратегическими целями развития
          Банка.
        </TabP>
        <TabTitle>Тренды</TabTitle>
        <TabP>
          Информация о трендах в развитии государственных цифровых инициатив
          необходима для своевременной адаптации к изменениям в
          законодательстве, технологических стандартах и требованиям к
          безопасности данных.
        </TabP>
        <TabP>
          Источники: «Основные направления развития финансовых технологий на
          период 2025-2026 гг.» (Банк России), исследования и аналитические
          материалы АФТ, иные аналитические издания.
        </TabP>
      </TabBlockAside> */}
    </div>
  );
};

export default SidebarInfoStateInitiative;
